module.exports = __webpack_public_path__ + "static/media/activate.0206c924.svg";